import axios from "axios"
import * as actions from "../actions/annualReturn"

export function addAnnualReturn(annualReturn) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/annual-return/`, annualReturn)
        .then(response => {
          if (response.data.Success) {
            // update store with annual return view model returned from the server
            dispatch(actions.getAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getAnnualReturnsForLobbyist(lobbyistId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/annual-return?lobbyistId=${lobbyistId}`)
      .then((response) => {
        let lobbyistAnnualReturns = response.data ? response.data.$values : []
        dispatch(actions.getAnnualReturnsForLobbyist(lobbyistAnnualReturns))
      })
  }
}

export function getAnnualReturn(lobbyistId, annualReturnId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/annual-return/${lobbyistId}/${annualReturnId}`)
      .then(response => dispatch(actions.getAnnualReturn(response.data)))
  }
}

export function exportAnnualReturnsToExcel(annualReturnRange) {
  return (dispatch) => {
    return axios.post(`${process.env.REACT_APP_API_HOST}/api/annual-return/export`, annualReturnRange, {
      // VERY IMPORTANT - none of the files that get returned will open correctly without this
      responseType: 'blob'
    })
  }
}

export function submitAnnualReturn(annualReturn) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/annual-return/${annualReturn.LobbyistId}/${annualReturn.AnnualReturnId}/submit`, annualReturn)
        .then(response => {
          if (response.data.Success) {
            // update store with annual return view model returned from the server
            dispatch(actions.getAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function updateAnnualReturn(annualReturn) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/annual-return/${annualReturn.LobbyistId}/${annualReturn.AnnualReturnId}/update`, annualReturn)
        .then(response => {
          if (response.data.Success) {
            // update store with annual return view model returned from the server
            dispatch(actions.getAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function approveAnnualReturn(lobbyistId, annualReturnId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/annual-return/${lobbyistId}/${annualReturnId}/approve`)
        .then(response => {
          if (response.data.Success) {
            // update store with annual return view model returned from the server
            dispatch(actions.getAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteAnnualReturn(annualReturnId) {
  return (dispatch) => {
    return axios.delete(`${process.env.REACT_APP_API_HOST}/api/annual-return/${annualReturnId}`)
  }
}

export function clearAnnualReturnsFromLobbyist() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearAnnualReturnsFromLobbyist())
      resolve()
    })
  }
}

export function getChangesRequired(annualReturnId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/annual-return/${annualReturnId}/changes-required`)
      .then((response) => {
        let changesRequired = response && response.data ? response.data : {}
        dispatch(actions.getChangesRequired(changesRequired))
      })
  }
}

export function changesRequired(annualReturn) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/annual-return/${annualReturn.LobbyistId}/changes-required`, annualReturn)
        .then(response => {
          if (response.data.Success) {
            // update store with lobbyist view model returned from the server
            dispatch(actions.getAnnualReturn(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function rejectFinalAnnualReturn(lobbyistId,annualReturnId) {
  return (dispatch) => {
    return axios.put(`${process.env.REACT_APP_API_HOST}/api/annual-return/${lobbyistId}/${annualReturnId}/reject`)
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/annualReturn.js